// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3b29e300","732":"3d8fc59f","977":"00b70099"}[chunkId] + ".chunk.js";
};